<div class="app-works-main-container" *ngIf="showEmptyHeader">
    <div class="app-works-header">
        <img
            src="../../../assets/img/welltrack-logos/well-track-white-logo.svg"
            alt="welltrack-logo" />
        <div class="app-works-header-bg">
            <svg-icon icon="app-works-header-bg"></svg-icon>
        </div>
    </div>
</div>

<page-loader *ngIf="!isLoaded"></page-loader>
<div class="app-l-page-wrap" cdkTrapFocus role="dialog" aria-modal="true">
    <div class="app-l-feedback-container">
        <h1 class="app-l-feedback__title">
            {{
                'dynamicForm.dynamicTitle' + apiDAta
                    | translate: { value: apiDAta }
            }}
        </h1>

        <p
            class="app-c-stepper__auto-advance-hint app-c-body-text--12"
            *ngIf="(showUserSurvey || showDemographSurvey) && currentStepAutoAdvances"
            translate>
            a11y.autoAdvance
        </p>
        <p
            class="sr-only"
            aria-live="polite"
            aria-atomic="true"
            *ngIf="formData.length > 1">
            {{ stepAnnouncement }}
        </p>

        <div class="app-c-stepper">
            <!--STEPPERS START-->
            <div
                class="steps-container"
                #stepsContainer
                *ngIf="showUserSurvey || showDemographSurvey || showNpsSurvey">
                <ul class="progressbar" *ngIf="formData.length > 1">
                    <ng-container
                        *ngFor="let data of formData; let dataIndex = index">
                        <li
                            [ngClass]="{
                                active: slideIndex === dataIndex,
                                completed:
                                    slideIndex != dataIndex &&
                                    dynamicForm.get(data.Key).value,
                            }"
                            [attr.aria-current]="
                                slideIndex === dataIndex ? 'step' : null
                            "
                            [attr.aria-label]="
                                stepStatusLabel(
                                    dataIndex,
                                    slideIndex != dataIndex &&
                                        !!dynamicForm.get(data.Key).value
                                )
                            "
                            translate>
                            dynamicForm.step <span>{{ dataIndex + 1 }}</span>
                        </li>
                    </ng-container>
                    <li
                        *ngIf="
                            isEapOrg &&
                            showDemographSurvey &&
                            employers.length > 0
                        "
                        [ngClass]="{
                            active: slideIndex === formData.length,
                            completed: slideIndex > formData.length,
                        }"
                        [attr.aria-current]="
                            slideIndex === formData.length ? 'step' : null
                        "
                        [attr.aria-label]="
                            stepStatusLabel(
                                formData.length,
                                slideIndex > formData.length
                            )
                        "
                        translate>
                        dynamicForm.step <span>{{ formData.length + 1 }}</span>
                    </li>
                </ul>
            </div>
            <!--STEPPERS END-->
            <div
                *ngIf="showUserSurvey || showDemographSurvey"
                class="app-c-stepper__content__wrap">
                <div
                    *ngFor="let data of formData; let i = index"
                    [ngClass]="{ active: active === i }"
                    class="formContainer"
                    style="overflow-y: auto">
                    <ng-container
                        [ngTemplateOutlet]="formFieldTemplate"
                        [ngTemplateOutletContext]="{ value: data, index: i }">
                    </ng-container>
                </div>
                <!-- Employer selection step (Step 5) for EAP organizations -->
                <div
                    *ngIf="
                        isEapOrg &&
                        showDemographSurvey &&
                        employers.length > 0 &&
                        slideIndex === formData.length
                    "
                    class="formContainer eap-employer-step">
                    <form [formGroup]="dynamicForm" novalidate>
                        <div class="app-c-stepper__content__wrap">
                            <div
                                class="app-c-stepper__content radio-section likeDislikeContent formContainer_body">
                                <h2 class="app-c-stepper__question-block">
                                    {{
                                        'dynamicForm.selectEmployer' | translate
                                    }}
                                </h2>
                                <p class="app-c-stepper__question-desc">
                                    {{
                                        'dynamicForm.chooseEmployer' | translate
                                    }}
                                </p>
                                <div
                                    *ngIf="selectedEmployerName"
                                    class="eap-employer-selected">
                                    <p class="eap-employer-selected-name">
                                        {{ selectedEmployerName }}
                                    </p>
                                    <a
                                        class="eap-employer-change-link"
                                        (click)="clearEmployerSelection()"
                                        translate
                                        >setting.changeEmployer</a
                                    >
                                </div>
                                <mat-form-field
                                    *ngIf="!selectedEmployerName"
                                    appearance="outline"
                                    class="eap-employer-select">
                                    <mat-label>{{
                                        'dynamicForm.employerLabel' | translate
                                    }}</mat-label>
                                    <input
                                        matInput
                                        [formControl]="employerSearchControl"
                                        [matAutocomplete]="employerAuto"
                                        [placeholder]="
                                            'dynamicForm.employerSearchPlaceholder'
                                                | translate
                                        " />
                                    <mat-autocomplete
                                        #employerAuto="matAutocomplete"
                                        [displayWith]="displayEmployer"
                                        (optionSelected)="
                                            onEmployerSelected($event)
                                        ">
                                        <mat-option
                                            *ngFor="
                                                let employer of filteredEmployers
                                            "
                                            [value]="employer">
                                            {{ employer.Name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="app-c-stepper__footer">
                            <div class="app-c-stepper__footer__left">
                                <button
                                    tabindex="0"
                                    (click)="onPrevious()"
                                    class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--with-icon"
                                    translate>
                                    <svg-icon icon="arrow-left"></svg-icon>
                                    <span>{{
                                        'dynamicForm.back' | translate
                                    }}</span>
                                </button>
                            </div>
                            <div class="app-c-stepper__footer__right">
                                <button
                                    class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
                                    [ngClass]="{
                                        'btn-disabled': !selectedEmployerID,
                                    }"
                                    [disabled]="!selectedEmployerID"
                                    (click)="doSave()"
                                    translate>
                                    <span>{{
                                        'dynamicForm.finish' | translate
                                    }}</span>
                                    <svg-icon icon="arrow-right"></svg-icon>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!--NPS START-->
            <div *ngIf="showNpsSurvey" class="app-c-number-scale-blk">
                <div class="app-c-number-scale-content">
                    <div
                        *ngFor="
                            let data of [formData[slideIndex]];
                            let i = index
                        "
                        class="app-c-number-scale-content__inner">
                        <div
                            *ngIf="data['Type'] === 7; else otherType"
                            class="nps-survey-block">
                            <h2
                                class="app-c-stepper__question-block"
                                [attr.aria-label]="data['Comment']">
                                {{ data['Comment'] }}
                            </h2>
                            <app-number-scale
                                [scaleIndex]="i"
                                [scaleOptionValues]="data.options"
                                (onCompleted)="
                                    scaleSelectionCompleted($event)
                                "></app-number-scale>

                            <p
                                *ngIf="
                                    isSubmitted && isMainQuestionAnswered(data)
                                ">
                                {{ 'dynamicForm.fieldRequired' | translate }}
                            </p>

                            <div *ngIf="shownxtques && data.sub">
                                <div
                                    *ngFor="
                                        let subQn of data.sub;
                                        let j = index
                                    ">
                                    <div *ngIf="subQn['show']">
                                        <ng-container
                                            [ngTemplateOutlet]="
                                                formFieldTemplate
                                            "
                                            [ngTemplateOutletContext]="{
                                                value: subQn,
                                                index: j,
                                            }">
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ng-template #otherType>
                            <ng-container
                                [ngTemplateOutlet]="formFieldTemplate"
                                [ngTemplateOutletContext]="{
                                    value: data,
                                    index: i,
                                }">
                            </ng-container>
                        </ng-template>
                    </div>
                </div>
            </div>
            <!--NPS END-->
        </div>

        <!--USER SURVEY AND DEMOGRAPHIC START-->

        <ng-template let-data="value" let-index="index" #formFieldTemplate>
            <form [formGroup]="dynamicForm" novalidate>
                <div
                    *ngIf="index === slideIndex || showNpsSurvey"
                    class="app-c-stepper__content__wrap">
                    <div
                        class="app-c-stepper__content radio-section likeDislikeContent formContainer_body"
                        *ngIf="data['Type'] === 1">
                        <h2 class="app-c-stepper__question-block">
                            {{ data['Comment'] }}
                        </h2>
                        <p class="app-c-stepper__question-desc" translate>
                            dynamicForm.chooseOptionAppliesYou
                        </p>
                        <div
                            *ngIf="data['Type'] === 1"
                            aria-label="{{ data['Comment'] }}"
                            class="app-c-radio__like-group"
                            role="radiogroup">
                            <input
                                style="display: none"
                                type="text"
                                [formControlName]="data['Key']" />
                            <button
                                *ngFor="let opt of data.options; let j = index"
                                class="app-c-radio__like"
                                [ngClass]="{ active: optionType === opt.ID }"
                                (click)="valueChange(data, opt)"
                                role="radio"
                                [attr.aria-checked]="optionType === opt.ID"
                                [attr.aria-label]="opt.Comment"
                                tabindex="0">
                                <div *ngIf="isPositiveOption(opt)">
                                    <svg-icon icon="like"></svg-icon>
                                </div>
                                <div *ngIf="isNegativeOption(opt)">
                                    <svg-icon icon="dislike"></svg-icon>
                                </div>
                                <span>{{ opt.Comment }}</span>
                            </button>
                        </div>

                        <p
                            *ngIf="
                                isSubmitted &&
                                dynamicForm
                                    .get(data['Key'])
                                    .hasError('required')
                            ">
                            {{ 'dynamicForm.fieldRequired' | translate }}
                        </p>
                    </div>
                    <div
                        class="app-c-stepper__content checkbox-section formContainer_body"
                        *ngIf="data['Type'] === 2">
                        <h2 class="app-c-stepper__question-block" translate>
                            {{ data['Comment'] }}
                        </h2>
                        <p class="app-c-stepper__question-desc" translate>
                            dynamicForm.chooseOptionsAppliesYou
                        </p>
                        <div class="app-c-radio__horizontal__list">
                            <div
                                class="app-c-checkbox__horizontal"
                                *ngFor="let opt of data.options; let j = index"
                                [ngClass]="{
                                    active: isAnyOptionSelected(opt.ID),
                                }">
                                <label
                                    class="app-c-custom__select"
                                    [ngClass]="{
                                        active: isAnyOptionSelected(opt.ID),
                                    }"
                                    >
                                    <input
                                        type="checkbox"
                                        [checked]="opt.checked"
                                        [formControlName]="
                                            data['Key'] + '_' + j
                                        "
                                        (change)="
                                            valueChange(data, opt, $event, j)
                                        "
                                        (keydown.enter)="$event.preventDefault()"
                                        class="sr-only" />
                                    <span class="app-c-custom__select-text">{{
                                        opt['Comment']
                                    }}</span>
                                    <svg-icon
                                        icon="tick-circle"
                                        class="app-c-custom__select-icon"></svg-icon>
                                </label>
                            </div>
                        </div>
                        <p
                            *ngIf="
                                isSubmitted &&
                                dynamicForm
                                    .get(data['Key'])
                                    .hasError('required')
                            ">
                            {{ 'dynamicForm.fieldRequired' | translate }}
                        </p>
                    </div>

                    <div
                        class="app-c-stepper__content formContainer_body"
                        *ngIf="data['Type'] === 4">
                        <h2 class="app-c-stepper__question-block">
                            {{ data['Comment'] }}
                        </h2>
                        <p class="app-c-stepper__question-desc" translate>
                            dynamicForm.chooseOptionAppliesYou
                        </p>
                        <input
                            style="display: none"
                            type="text"
                            [formControlName]="data['Key']" />
                        <div
                            class="app-c-radio__horizontal__list"
                            role="radiogroup"
                            [attr.aria-label]="data['Comment']">
                            <div
                                *ngFor="let opt of data.options"
                                class="app-c-radio__horizontal"
                                role="radio"
                                [attr.aria-checked]="optionType === opt.ID"
                                [attr.aria-label]="opt.Comment"
                                tabindex="0"
                                (keydown.enter)="valueChange(data, $event, opt)"
                                (keydown.space)="valueChange(data, $event, opt)"
                                (click)="valueChange(data, $event, opt)"
                                [ngClass]="{ active: optionType === opt.ID }">
                                <span>{{ opt.Comment }}</span>
                                <svg-icon
                                    [ngClass]="{
                                        active: optionType === opt.ID,
                                    }"
                                    icon="tick-circle"></svg-icon>
                            </div>
                        </div>
                    </div>

                    <div
                        class="text-area-input-container formContainer_body app-c-stepper__content"
                        *ngIf="data['Type'] === 5">
                        <h2 class="app-c-stepper__question-block">
                            {{ data['Comment'] }}
                        </h2>
                        <p class="app-c-stepper__question-desc" translate>
                            dynamicForm.writeYourSuggestions
                        </p>
                        <div class="formContainer_body_textarea">
                            <div class="app-c-form-group">
                                <textarea
                                    [attr.aria-label]="data['Comment']"
                                    title="{{ data['Comment'] }}"
                                    placeholder="{{
                                        'dynamicForm.startType' | translate
                                    }}"
                                    [name]="data['Key']"
                                    class="app-c-form-control textArea_custom"
                                    [formControlName]="data['Key']"
                                    (change)="
                                        valueChange(
                                            data,
                                            $any($event.target).value
                                        )
                                    "></textarea>
                                <p
                                    *ngIf="
                                        isSubmitted &&
                                        dynamicForm
                                            .get(data['Key'])
                                            .hasError('required')
                                    ">
                                    {{
                                        'dynamicForm.fieldRequired' | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div
                        class="text-area-input-container formContainer_body app-c-stepper__content"
                        *ngIf="data['Type'] === 6">
                        <h2 class="app-c-stepper__question-block">
                            {{ data['Comment'] }}
                        </h2>
                        <p class="app-c-stepper__question-desc" translate>
                            dynamicForm.textDesc
                            <span translate>{{ data['Comment'] }}</span>
                        </p>
                        <div class="formContainer_body_textarea">
                            <div class="app-c-form-group">
                                <textarea
                                    [attr.aria-label]="data['Comment']"
                                    placeholder="{{ data['Comment'] }}"
                                    [name]="data['Key']"
                                    class="app-c-form-control textArea_custom"
                                    [formControlName]="data['Key']"
                                    (change)="
                                        valueChange(
                                            data,
                                            $any($event.target).value
                                        )
                                    "></textarea>
                                <p
                                    *ngIf="
                                        isSubmitted &&
                                        dynamicForm
                                            .get(data['Key'])
                                            .hasError('required')
                                    ">
                                    {{
                                        'dynamicForm.fieldRequired' | translate
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>

                     <div class="app-c-stepper__content formContainer_body" *ngIf="data['Type'] === 9">
  <h2 class="app-c-stepper__question-block">{{ data['Comment'] }}</h2>
  <p class="app-c-stepper__question-desc" translate>dynamicForm.provideDOB</p>

  <div class="app-l-dob-blk">

    <!-- Month -->
    <div class="app-l-dob-blk__item">
            <label id="dob-month-label" translate>dynamicForm.month</label>
      <div class="app-c-custom-select" [class.is-open]="isDobMonthOpen">
                <div class="app-c-select-trigger app-c-form-control"
                        role="combobox"
                        aria-haspopup="listbox"
                        aria-autocomplete="none"
                        aria-labelledby="dob-month-label"
                        id="dob-month-trigger"
                        [attr.aria-controls]="isDobMonthOpen ? 'dob-month-options' : null"
                        [attr.aria-expanded]="isDobMonthOpen"
                        tabindex="0"
                        (click)="openDropdown('month'); $event.stopPropagation()"
                        (keydown.enter)="openDropdown('month'); $event.stopPropagation()"
                        (keydown.space)="$event.preventDefault(); openDropdown('month'); $event.stopPropagation()"
                        (keydown.escape)="closeDobDropdown('month')">
          <span [class.placeholder]="!dynamicForm.get('selectedMonth')?.value">
            {{ getMonthLabel(dynamicForm.get('selectedMonth')?.value) || ('dynamicForm.month' | translate) }}
          </span>
        </div>
          <ul id="dob-month-options" class="app-c-select-list" *ngIf="isDobMonthOpen" role="listbox" aria-labelledby="dob-month-label" (keydown)="onDobListKeydown($event, 'month')" (click)="$event.stopPropagation()">
          <li *ngFor="let month of months"
              [class.is-selected]="dynamicForm.get('selectedMonth')?.value === month.value"
              role="option"
              tabindex="-1"
              [attr.aria-selected]="dynamicForm.get('selectedMonth')?.value === month.value"
              (click)="setDobValue('selectedMonth', month.value, data); closeDobDropdown('month')"
              (keydown.enter)="setDobValue('selectedMonth', month.value, data); closeDobDropdown('month')"
              (keydown.space)="$event.preventDefault(); setDobValue('selectedMonth', month.value, data); closeDobDropdown('month')">
            {{ month.label }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Date -->
    <div class="app-l-dob-blk__item">
    <label id="dob-date-label" translate>dynamicForm.date</label>
      <div class="app-c-custom-select" [class.is-open]="isDobDateOpen">
        <div class="app-c-select-trigger app-c-form-control"
        role="combobox"
        aria-haspopup="listbox"
        aria-autocomplete="none"
        aria-labelledby="dob-date-label"
        id="dob-date-trigger"
        [attr.aria-controls]="isDobDateOpen ? 'dob-date-options' : null"
        [attr.aria-expanded]="isDobDateOpen"
        tabindex="0"
        (click)="openDropdown('date'); $event.stopPropagation()"
        (keydown.enter)="openDropdown('date'); $event.stopPropagation()"
        (keydown.space)="$event.preventDefault(); openDropdown('date'); $event.stopPropagation()"
        (keydown.escape)="closeDobDropdown('date')">
          <span [class.placeholder]="!dynamicForm.get('selectedDate')?.value">
            {{ dynamicForm.get('selectedDate')?.value || ('dynamicForm.date' | translate) }}
          </span>
        </div>
          <ul id="dob-date-options" class="app-c-select-list" *ngIf="isDobDateOpen" role="listbox" aria-labelledby="dob-date-label" (keydown)="onDobListKeydown($event, 'date')" (click)="$event.stopPropagation()">
          <li *ngFor="let date of dates"
              [class.is-selected]="dynamicForm.get('selectedDate')?.value === date"
              role="option"
              tabindex="-1"
              [attr.aria-selected]="dynamicForm.get('selectedDate')?.value === date"
              (click)="setDobValue('selectedDate', date, data); closeDobDropdown('date')"
              (keydown.enter)="setDobValue('selectedDate', date, data); closeDobDropdown('date')"
              (keydown.space)="$event.preventDefault(); setDobValue('selectedDate', date, data); closeDobDropdown('date')">
            {{ date }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Year -->
    <div class="app-l-dob-blk__item">
    <label id="dob-year-label" translate>dynamicForm.year</label>
      <div class="app-c-custom-select" [class.is-open]="isDobYearOpen">
        <div class="app-c-select-trigger app-c-form-control"
        role="combobox"
        aria-haspopup="listbox"
        aria-autocomplete="none"
        aria-labelledby="dob-year-label"
        id="dob-year-trigger"
        [attr.aria-controls]="isDobYearOpen ? 'dob-year-options' : null"
        [attr.aria-expanded]="isDobYearOpen"
        tabindex="0"
        (click)="openDropdown('year'); $event.stopPropagation()"
        (keydown.enter)="openDropdown('year'); $event.stopPropagation()"
        (keydown.space)="$event.preventDefault(); openDropdown('year'); $event.stopPropagation()"
        (keydown.escape)="closeDobDropdown('year')">
          <span [class.placeholder]="!dynamicForm.get('selectedYear')?.value">
            {{ dynamicForm.get('selectedYear')?.value || ('dynamicForm.year' | translate) }}
          </span>
        </div>
          <ul id="dob-year-options" class="app-c-select-list" *ngIf="isDobYearOpen" role="listbox" aria-labelledby="dob-year-label" (keydown)="onDobListKeydown($event, 'year')" (click)="$event.stopPropagation()">
          <li *ngFor="let year of years"
              [class.is-selected]="dynamicForm.get('selectedYear')?.value === year"
              role="option"
              tabindex="-1"
              [attr.aria-selected]="dynamicForm.get('selectedYear')?.value === year"
              (click)="setDobValue('selectedYear', year, data); closeDobDropdown('year')"
              (keydown.enter)="setDobValue('selectedYear', year, data); closeDobDropdown('year')"
              (keydown.space)="$event.preventDefault(); setDobValue('selectedYear', year, data); closeDobDropdown('year')">
            {{ year }}
          </li>
        </ul>
      </div>
    </div>

  </div>

  <div *ngIf="data['Group'] != 'age'">
    <div class="input-item age-input-section">
      <input matInput
          placeholder="{{ 'dynamicForm.date' | translate }}"
          [name]="data['Key']"
          type="text"
          [formControlName]="data['Key']"
          (change)="valueChange($event, data)" />
    </div>
    <p *ngIf="isSubmitted && dynamicForm.get(data['Key']).hasError('required')"
        class="form-error error red">
      *{{ 'dynamicForm.fieldRequired' | translate }}
    </p>
  </div>
</div>

                    <div
                        class="viewlabel formContainer_body"
                        *ngIf="data['Type'] === 8">
                        <label>{{ data['Comment'] }}</label>
                        <div class="formContainer_body_inputNumber">
                            <div class="app-c-form-group">
                                <label class="app-c-form--label" translate>
                                    dynamicForm.textDesc
                                    <span>{{ data['Comment'] }}</span>
                                </label>
                                <input
                                    class="app-c-form-control"
                                    type="number"
                                    [min]="data['validations']['min'] || 0"
                                    [max]="data['validations']['max'] || 0"
                                    [formControlName]="data['Key']"
                                    placeholder="Enter"
                                    (keyup)="
                                        valueChange(
                                            data,
                                            $any($event.target).value
                                        )
                                    " />
                                <div
                                    class="error-message"
                                    *ngIf="
                                        dynamicForm
                                            .get(data['Key'])
                                            .hasError('required')
                                    ">
                                    {{
                                        'dynamicForm.fieldRequired' | translate
                                    }}
                                </div>
                                <div
                                    class="error-message"
                                    *ngIf="data['Key'].invalid">
                                    {{
                                        'dynamicForm.fieldRequired' | translate
                                    }}
                                </div>
                                <div
                                    class="error-message"
                                    *ngIf="
                                        dynamicForm
                                            .get(data['Key'])
                                            .hasError('notMatched')
                                    ">
                                    {{
                                        'dynamicForm.invalid'
                                            | translate
                                                : {
                                                      minval: minval,
                                                      maxval: maxval,
                                                  }
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--FOOTER START showUserSurvey || showDemographSurvey-->
                    <div
                        class="app-c-stepper__footer"
                        *ngIf="showUserSurvey || showDemographSurvey">
                        <div class="app-c-stepper__footer__left">
                            <button
                                tabindex="0"
                                (click)="onPrevious()"
                                *ngIf="slideIndex != 0"
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--with-icon"
                                translate>
                                <svg-icon icon="arrow-left"></svg-icon>
                                <span>{{
                                    'dynamicForm.back' | translate
                                }}</span>
                            </button>
                        </div>
                        <div class="app-c-stepper__footer__right">
                            <!-- Continue: show on all steps except the final one -->
                            <button
                                class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
                                (click)="onNext()"
                                *ngIf="
                                    isEapOrg && employers.length > 0
                                        ? slideIndex < formData.length
                                        : slideIndex < formData.length - 1
                                "
                                [disabled]="
                                    slideIndex < formData.length &&
                                    formData[slideIndex] &&
                                    !dynamicForm.get(formData[slideIndex].Key)?.valid
                                "
                                [ngClass]="{
                                    'btn-disabled':
                                        slideIndex < formData.length &&
                                        formData[slideIndex] &&
                                        !dynamicForm.get(
                                            formData[slideIndex].Key
                                        ).valid,
                                }"
                                translate>
                                <span>{{
                                    'dynamicForm.continue' | translate
                                }}</span>
                                <svg-icon icon="arrow-right"></svg-icon>
                            </button>
                            <!-- Finish: show on employer step (or last form step if no employers) -->
                            <button
                                class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
                                [ngClass]="{
                                    'btn-disabled': !dynamicForm.valid,
                                }"
                                *ngIf="
                                    isEapOrg && employers.length > 0
                                        ? slideIndex === formData.length
                                        : slideIndex === formData.length - 1
                                "
                                (click)="doSave()"
                                translate>
                                <span>{{
                                    'dynamicForm.finish' | translate
                                }}</span>
                                <svg-icon icon="arrow-right"></svg-icon>
                            </button>
                        </div>
                    </div>
                    <!--FOOTER END-->
                    <!--FOOTER START showNpsSurvey-->
                    <div class="app-c-stepper__footer" *ngIf="showNpsSurvey">
                        <div class="app-c-number-scale__footer__left">
                            <button
                                tabindex="0"
                                *ngIf="slideIndex != 0"
                                (click)="prevData()"
                                class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--with-icon"
                                translate>
                                <svg-icon icon="arrow-left"></svg-icon>
                                <span>{{
                                    'dynamicForm.back' | translate
                                }}</span>
                            </button>
                        </div>
                        <div class="app-c-stepper__footer__right">
                            <div class="app-c-stepper__footer__right">
                                <button
                                    class="app-c-btn app-c-btn--primary app-c-btn--curve"
                                    (click)="onNext()"
                                    *ngIf="slideIndex < formData.length - 1"
                                    [disabled]="
                                        !dynamicForm.get(data['Key']).valid
                                    "
                                    translate>
                                    {{ 'dynamicForm.continue' | translate }}
                                    <svg-icon icon="arrow-right"></svg-icon>
                                </button>
                            </div>
                            <button
                                class="app-c-btn app-c-btn--primary app-c-btn--with-icon app-c-btn--curve app-c-btn--with-icon"
                                *ngIf="slideIndex === formData.length - 1"
                                [disabled]="!dynamicForm.get(data['Key']).valid"
                                (click)="doSave()"
                                translate>
                                <span translate> dynamicForm.finish </span>
                                <svg-icon icon="arrow-right"></svg-icon>
                            </button>
                        </div>
                    </div>
                    <!--FOOTER END-->
                </div>
            </form>
        </ng-template>
        <!--USER SURVEY AND DEMOGRAPHIC END-->
    </div>
    <div class="app-c-accordion app-c-accordion__survey">
        <details class="app-c-expansion-panel">
            <summary class="app-c-expansion-panel">
                <span class="app-c-expansion-panel__title" translate
                    >dynamicForm.aboutSurvey</span
                >
            </summary>
            <ng-container
                *ngIf="
                    userData.primaryOrganization &&
                        userData.primaryOrganization.serviceType === 1;
                    else servicetypetwo
                ">
                <p translate>dynamicForm.contentStudent</p>
            </ng-container>
            <ng-template #servicetypetwo>
                <ng-container
                    *ngIf="
                        userData.primaryOrganization &&
                            userData.primaryOrganization.serviceType === 2;
                        else servicetypethree
                    ">
                    <p translate>dynamicForm.contentEmployer</p>
                </ng-container>
            </ng-template>
            <ng-template #servicetypethree>
                <ng-container
                    *ngIf="
                        userData.primaryOrganization &&
                            userData.primaryOrganization.serviceType === 3;
                        else servicetypefour
                    ">
                    <p translate>dynamicForm.contentCommunity</p>
                </ng-container>
            </ng-template>
            <ng-template #servicetypefour>
                <ng-container
                    *ngIf="
                        userData.primaryOrganization &&
                            userData.primaryOrganization.serviceType === 4;
                        else servicetypedefault
                    ">
                    <p translate>dynamicForm.contentManagedcare</p>
                </ng-container>
            </ng-template>
            <ng-template #servicetypedefault>
                <p translate>dynamicForm.contentDefault</p>
            </ng-template>
        </details>
    </div>
</div>
